/* ============================================================
   Notre Chanson — shopify.js
   Turns the saved brief + cart into a real Shopify checkout via
   the Storefront API `cartCreate` mutation. Returns the store's
   hosted checkout URL, where the customer pays and the order is
   created natively in Shopify.

   No secret is used here: NM_SHOPIFY.storefrontToken is a PUBLIC
   Storefront token. The request is CORS-allowed from any origin.

   Public API:
     NMShopify.isConfigured()  -> bool
     NMShopify.checkout()      -> Promise<{url}|{error}>
   ============================================================ */
(function (global) {
  'use strict';

  var CFG = global.NM_SHOPIFY || {};

  function filled(v) { return typeof v === 'string' && v && v.indexOf('XXX') === -1 && v.indexOf('COLLE_') === -1 && v.indexOf('TA-') === -1; }

  function isConfigured() {
    return !!(CFG.enabled &&
      filled(CFG.domain) &&
      filled(CFG.storefrontToken) &&
      CFG.variants && filled(CFG.variants.song));
  }

  /* Build the cart lines: base song (with the full brief as line-item
     properties) + any selected order bumps. */
  function buildLines() {
    var A = NM.answers, S = NM.state;
    var attrs = [
      { key: 'Pour',          value: A.prenom || NM.relationLabel() },
      { key: 'Style musical', value: NM.genreLabel() },
      { key: 'Voix',          value: NM.voiceLabel() }
    ];
    if (A.pronunciation) attrs.push({ key: 'Prononciation', value: A.pronunciation });
    if (A.qualities)     attrs.push({ key: 'Qualités',      value: A.qualities });
    if (A.souvenirs)     attrs.push({ key: 'Souvenirs',     value: clip(A.souvenirs) });
    if (A.message)       attrs.push({ key: 'Message',       value: clip(A.message) });

    var lines = [{
      merchandiseId: CFG.variants.song,
      quantity: S.product.qty || 1,
      attributes: attrs
    }];

    Object.keys(S.bumps).forEach(function (id) {
      if (S.bumps[id] && filled(CFG.variants[id])) {
        lines.push({ merchandiseId: CFG.variants[id], quantity: 1 });
      }
    });

    /* Pourboire (facultatif) — une variante à prix fixe. */
    if (S.tip && filled(CFG.variants[S.tip])) {
      lines.push({ merchandiseId: CFG.variants[S.tip], quantity: 1 });
    }
    return lines;
  }

  /* Une option n'est proposée au client que si sa variante existe,
     sinon le total affiché ne correspondrait pas au montant encaissé. */
  function hasVariant(id) { return filled(CFG.variants && CFG.variants[id]); }

  /* Shopify line-item property values are capped; keep them safe. */
  function clip(s) { return String(s).slice(0, 950); }

  function checkout() {
    var query =
      'mutation cartCreate($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    cart { id checkoutUrl }' +
      '    userErrors { field message }' +
      '  }' +
      '}';

    var input = { lines: buildLines(), attributes: [{ key: 'source', value: 'notrechanson-funnel' }] };
    var bi = {};
    if (NM.state.email) bi.email = NM.state.email;
    /* Pays du visiteur (Shopify Markets) -> checkout dans la bonne devise. */
    if (window.NM_MONEY && NM_MONEY.country) bi.countryCode = NM_MONEY.country;
    if (bi.email || bi.countryCode) input.buyerIdentity = bi;

    var url = 'https://' + CFG.domain + '/api/' + (CFG.apiVersion || '2024-10') + '/graphql.json';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: { input: input } })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var d = json && json.data && json.data.cartCreate;
        if (d && d.cart && d.cart.checkoutUrl) return { url: d.cart.checkoutUrl };
        var msg = (d && d.userErrors && d.userErrors[0] && d.userErrors[0].message) ||
                  (json.errors && json.errors[0] && json.errors[0].message) ||
                  'Réponse Shopify inattendue.';
        return { error: msg };
      })
      .catch(function (e) { return { error: (e && e.message) || 'Connexion à Shopify impossible.' }; });
  }

  global.NMShopify = { isConfigured: isConfigured, checkout: checkout, hasVariant: hasVariant };
})(window);
